document.addEventListener("DOMContentLoaded", function () {
  const variantsEl = document.querySelector("[data-variants]");
  const badgesEl = document.querySelector("[data-badges]");

  if (!variantsEl || !badgesEl) return;

  let variants = [];
  let badgeMap = {};

  try {
    variants = JSON.parse(variantsEl.textContent).variants || [];
  } catch (err) {
    console.error("Could not parse [data-variants] JSON", err);
    return;
  }

  try {
    badgeMap = JSON.parse(badgesEl.textContent).variantBadges || {};
  } catch (err) {
    console.error("Could not parse [data-badges] JSON", err);
    return;
  }

  if (!variants.length) return;

  function getOptionNamesInOrder() {
    const names = [];
    document.querySelectorAll(".product-option__radio").forEach((radio) => {
      if (!names.includes(radio.name)) names.push(radio.name);
    });
    return names;
  }

  function getSelectedOptions(optionNames) {
    return optionNames.map((name) => {
      const checked = document.querySelector(
        `.product-option__radio[name="${CSS.escape(name)}"]:checked`
      );
      return checked ? checked.value : null;
    });
  }

  function updateBadges() {
    const allRadios = Array.from(document.querySelectorAll(".product-option__radio"));
    if (!allRadios.length) return;

    const optionNames = getOptionNamesInOrder();
    const selectedOptions = getSelectedOptions(optionNames);

    allRadios.forEach((radio) => {
      const label = document.querySelector(`label[for="${CSS.escape(radio.id)}"]`);
      if (!label) return;

      const badgeEl = label.querySelector(".variant-value");
      if (!badgeEl) return;

      const optionPosition = optionNames.indexOf(radio.name);
      if (optionPosition === -1) {
        badgeEl.textContent = "";
        return;
      }

      const candidateOptions = selectedOptions.slice();
      candidateOptions[optionPosition] = radio.value;

      const matched = variants.find((variant) => {
        if (!Array.isArray(variant.options)) return false;
        if (variant.options.length !== candidateOptions.length) return false;

        return variant.options.every((opt, i) => opt === candidateOptions[i]);
      });

      badgeEl.textContent = matched ? (badgeMap[String(matched.id)] || "") : "";
    });
  }

  updateBadges();

  document.addEventListener("change", function (event) {
    if (event.target && event.target.matches(".product-option__radio")) {
      updateBadges();
    }
  });
});